<template>
  <div
    class="jobDetail mobileJobDetail"
    :class="{ 'font-size-18 desktopJobDetail': $store.state.innerWidth > 768 }"
    v-if="jobPostingDetail"
  >
    <div class="row courses-content">
      <div class="coursesPC">
        <div class="assistant">
          <div class="a-content row">
            <Breadcrumbs v-if="$store.state.innerWidth <= 768"></Breadcrumbs>
            <h2
              class="col-sm-12 SemiBold"
              :class="{ 'font-size-36': $store.state.innerWidth > 768 }"
              v-html="$store.getters.getContent(jobPostingDetail.title)"
            ></h2>
            <div class="row col-sm-12 itemContent">
              <div
                class="col-sm-6 padLeft-0"
                v-if="$store.getters.getContent(jobPostingDetail.organization)"
              >
                <div class="item-table pad-7">
                  <div class="tdcell iconWidth">
                    <i class="icon-hourse"></i>
                  </div>
                  <div class="tdcell pad-l-10">
                    <p class="opacity-5">{{ $t("message.Organization") }}</p>
                    <p
                      class="wrap"
                      v-html="
                        $store.getters.getContent(jobPostingDetail.organization)
                      "
                    ></p>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-6 padLeft-0"
                v-if="$store.getters.getContent(jobPostingDetail.department)"
              >
                <div class="item-table pad-7">
                  <div class="tdcell iconWidth">
                    <i class="icon-user"></i>
                  </div>
                  <div class="tdcell pad-l-10">
                    <p class="opacity-5">{{ $t("message.Department") }}</p>
                    <p
                      class="wrap"
                      v-html="
                        $store.getters.getContent(jobPostingDetail.department)
                      "
                    ></p>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-6 padLeft-0"
                v-if="jobPostingDetail.jobFunction.length"
              >
                <div class="item-table pad-7">
                  <div class="tdcell iconWidth">
                    <i class="icon-box"></i>
                  </div>
                  <div class="tdcell pad-l-10">
                    <p class="opacity-5">{{ $t("message.Job function(s)") }}</p>
                    <p
                      class="wrap"
                      v-if="jobPostingDetail.jobFunction"
                      v-for="job in jobPostingDetail.jobFunction"
                    >
                      {{ $store.getters.getContent(job.title) }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-6 padLeft-0"
                v-if="
                  jobPostingDetail.level && jobPostingDetail.level.length > 0
                "
              >
                <div class="item-table pad-7">
                  <div class="tdcell iconWidth">
                    <i class="icon-rocket"></i>
                  </div>
                  <div class="tdcell pad-l-10">
                    <p class="opacity-5">
                      {{ $t("message.Level of position") }}
                    </p>
                    <p class="wrap">
                      {{ $store.getters.getContent(jobPostingDetail.level) }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-6 padLeft-0"
                v-if="$store.getters.getContent(jobPostingDetail.salary)"
              >
                <div class="item-table pad-7">
                  <div class="tdcell iconWidth">
                    <i class="icon-cash"></i>
                  </div>
                  <div class="tdcell pad-l-10">
                    <p class="opacity-5">{{ $t("message.Salary") }}</p>
                    <p class="wrap">
                      {{ $store.getters.getContent(jobPostingDetail.salary) }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-6 padLeft-0"
                v-if="
                  jobPostingDetail.benefits && jobPostingDetail.benefits.length
                "
              >
                <div class="item-table pad-7">
                  <div class="tdcell iconWidth">
                    <i class="icon-benefits"></i>
                  </div>
                  <div class="tdcell pad-l-10">
                    <p class="opacity-5">{{ $t("message.benefits") }}</p>
                    <p
                      class="wrap"
                      v-if="jobPostingDetail.benefits"
                      v-for="benefits in jobPostingDetail.benefits"
                    >
                      {{ benefits }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-6 padLeft-0"
                v-if="jobPostingDetail.location.length"
              >
                <div class="item-table pad-7">
                  <div class="tdcell iconWidth">
                    <i class="icon-location"></i>
                  </div>
                  <div class="tdcell pad-l-10">
                    <p class="opacity-5">{{ $t("message.location") }}</p>
                    <p
                      class="wrap"
                      v-if="jobPostingDetail.location"
                      v-for="location in jobPostingDetail.location"
                    >
                      {{ location }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="description jobDescLi">
          <div class="pad-15 row">
            <h2
              class="SemiBold"
              :class="{ 'font-size-30': $store.state.innerWidth > 768 }"
            >
              {{ $t("message.Job descriptions") }}
            </h2>
            <!-- job duties -->
            <h4
              class="SemiBold"
              :class="{ 'font-size-21': $store.state.innerWidth > 768 }"
            >
              {{ $t("message.Job duties") }}
            </h4>
            <p
              class="wrap"
              v-html="$store.getters.getContent(jobPostingDetail.duties)"
            ></p>

            <!-- job Requirements-->
            <h4
              style="margin-top: 30px"
              class="SemiBold"
              v-if="$store.getters.getContent(jobPostingDetail.requirement)"
              :class="{ 'font-size-21': $store.state.innerWidth > 768 }"
            >
              {{ $t("message.Requirements") }}
            </h4>
            <p
              class="wrap"
              v-if="
                $store.getters.getContent(jobPostingDetail.requirement) &&
                (showMore || $store.state.innerWidth > 768)
              "
              v-html="$store.getters.getContent(jobPostingDetail.requirement)"
            ></p>

            <div
              class="border"
              v-if="
                $store.state.innerWidth <= 768 &&
                $store.getters.getContent(jobPostingDetail.requirement)
              "
            ></div>
            <div
              class="more"
              v-if="
                $store.state.innerWidth <= 768 &&
                $store.getters.getContent(jobPostingDetail.requirement)
              "
            >
              <div class="moreBtn" @click="showMore = !showMore">
                <span class="Bold" v-if="!showMore">{{
                  $t("message.Show more")
                }}</span>
                <span class="Bold" v-if="showMore">{{
                  $t("message.Show less")
                }}</span>
                <span class="pad-lr-10">
                  <i class="icon-arrow-down" :class="{ tran180: showMore }"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="advertisingDate">
          <div class="pad-15 row">
            <h2
              class="SemiBold"
              :class="{ 'font-size-30': $store.state.innerWidth > 768 }"
            >
              {{ $t("message.Advertising date") }}
            </h2>
            <p>
              {{ $store.getters.formatDate(jobPostingDetail.advertisingDate) }}
            </p>
            <div
              class="pad-tb-50"
              :class="{ center: $store.state.innerWidth <= 768 }"
            >
              <div
                class="btn btn-primary SemiBold"
                style="width: unset; padding: 10px 17px !important"
                @click="applyEvent"
                role="button"
                :aria-label="$t('message.Apply')"
                v-if="
                  $store.getters.getContent(this.jobPostingDetail.onlineformURL)
                "
              >
                <span
                  v-if="
                    jobPostingDetail.jobType != 1 &&
                    jobPostingDetail.jobType != 7
                  "
                  ><a href="javascript:;" style="color: inherit"
                    >{{ $t("message.Apply on") }}
                    {{ jobPostingDetail.jobSource }}
                    {{ $t("message.Apply on2") }}</a
                  ></span
                >
                <span
                  v-if="
                    jobPostingDetail.jobType == 1 ||
                    jobPostingDetail.jobType == 7
                  "
                  ><a href="javascript:;" style="color: inherit">{{
                    $t("message.Apply")
                  }}</a></span
                >
              </div>
            </div>
            <ShareBar :jobPostingId="jobPostingId"></ShareBar>
          </div>
        </div>
        <div class="tAndC">
          <div class="text">
            {{ $t("message.jobTAndC") }}
          </div>
        </div>

        <!-- related job -->
        <div class="similar otherJob" v-if="haveRelated&&!showJobCourse">
          <div class="row">
            <div class="mainColor box-img-bg SemiBold job-title">
              <h2>
                {{ $t("message.Other Job Opportunities") }}
                <img
                  class="noSelect"
                  src="../images/Vector Smart Object20.png"
                />
              </h2>
            </div>
            <Swiper
              id="Swiper"
              :width="swiperWidth"
              :hidejob="hideJob"
              :jobid="jobid"
              :jobfilterobj="jobFilterObj"
              :job-function-ids="jobFunctionIds"
              :callback="init"
              :list-type="2"
            ></Swiper>
            <div class="center pad-tb-50">
              <div
                class="btn btn-primary"
                @click="goJobList"
                role="button"
                :aria-label="$t('message.ViewAll')"
              >
                {{ $t("message.ViewAll") }}
              </div>
            </div>
          </div>
        </div>

        <!-- related course -->
        <div
          class="jobCourse "
          v-if="showJobCourse && activeCourses.length > 0"
        >
          <div class="mainColor">
            <h2 class="course-title">
              {{ $t("message.RelatedCourses") }}
              <img
                class="relatedCourse-deco-16 noSelect"
                src="../images/deco-16.png"
              />
            </h2>
          </div>
          <div
            class="
              buttonList
              col-xs-12 col-sm-12 col-md-12
              buttonList-CoursesJia
              item-table
            "
          >
            <button
              class="greenBtn btnExpand tdcell greenBtnLeft SemiBold"
              :class="activeType == 1 ? 'active' : ''"
              v-on:click="changeCourses('qrCourse', 1)"
              v-if="courses.qrCourse.length > 0"
            >
              <a href="javascript:;" style="color: inherit">{{
                $t("message.QR Courses")
              }}</a>
            </button>
            <button
              class="greenBtn btnExpand tdcell SemiBold"
              :class="activeType == 2 ? 'active' : ''"
              v-on:click="changeCourses('edxCourse', 2)"
              v-if="courses.edxCourse.length > 0"
            >
              <a href="javascript:;" style="color: inherit">{{
                $t("message.MOOC Courses")
              }}</a>
            </button>
          </div>

          <div class="courses-list">
            <div
              class="couses-item minHeight pointer"
              v-for="(course, index) in activeCourses"
              :class="activeCourses.length == index + 1 ? '' : 'mgRight-10'"
              @click="goCourseDetail(course)"
            >
              <div class="flex-span">
                <span
                  class="timeTip timeTipJia SemiBold nowrap"
                  v-if="
                    $store.getters.getTrim(mode) == 'FT' ||
                    $store.getters.getTrim(mode) == 'PT' ||
                    $store.getters.getTrim(mode) == 'DL' ||
                    $store.getters.getTrim(mode) == 'EL'
                  "
                  v-for="(mode, index) in course.learningMode"
                  :key="index"
                >
                  {{ $t("message." + $store.getters.getTrim(mode) + "") }}
                </span>
              </div>
              <div>
                <a href="javascript:;" style="color: inherit">
                  <h4 class="SemiBold courseTitle fourline-box wrap">
                    {{ $store.getters.getObject(course.langMap).title }}
                  </h4>
                </a>
                <div class="twoline-box wrap">
                  <p>
                    {{
                      $store.getters.getObject(course.langMap).grantingBody[0]
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="center">
            <div
              class="btn btn-primary op-rc-Btn btnJia SemiBold"
              @click="viewAllCoursesEvent()"
              role="button"
              :aria-label="$t('message.View all QR Courses')"
              v-if="activeType == 1 && courses.qrCourse.length > 5"
            >
              <a href="javascript:;" style="color: inherit"
                >{{ $t("message.View all QR Courses") }} ( {{ courseNum }} )</a
              >
            </div>
            <div
              class="btn btn-primary op-rc-Btn btnJia SemiBold"
              @click="viewAllCoursesEvent()"
              role="button"
              :aria-label="$t('message.View all MOOC Courses')"
              v-if="activeType == 2 && courses.edxCourse.length > 5"
            >
              <a href="javascript:;" style="color: inherit"
                >{{ $t("message.View all MOOC Courses") }} (
                {{ courseNum }} )</a
              >
            </div>
          </div>
        </div>

        <!-- mobile related course -->
        <div
          class="jobCourseMobile otherJob"
          v-if="!showJobCourse && activeCourses.length > 0"
        >
          <div class="mainColor">
            <h2 class="course-title">
              {{ $t("message.RelatedCourses") }}
              <img
                class="relatedCourse-deco-16 noSelect"
                src="../images/deco-16.png"
              />
            </h2>
          </div>
          <div class="buttonList buttonList-CoursesJia item-table">
            <button
              class="greenBtn btnExpand tdcell greenBtnLeft SemiBold"
              :class="courseType == 1 ? 'active' : ''"
              v-on:click="clickCourses(1, 'Common Skills')"
              v-if="courses.qrCourse.length > 0"
            >
              {{ $t("message.QR Courses") }}
            </button>
            <button
              class="greenBtn btnExpand tdcell SemiBold"
              :class="courseType == 2 ? 'active' : ''"
              v-on:click="clickCourses(2, 'Growing skills')"
              v-if="courses.edxCourse.length > 0"
            >
              {{ $t("message.MOOC Courses") }}
            </button>
          </div>
          <SwiperQRcourses
            :course-list="courses.qrCourse"
            v-if="courseType == 1 && courses.qrCourse.length > 0"
          ></SwiperQRcourses>
          <SwiperMOOCcourses
            :course-list="courses.edxCourse"
            v-if="courseType == 2 && courses.edxCourse.length > 0"
          ></SwiperMOOCcourses>
          <div class="center">
            <div
              class="btn btn-primary SemiBold"
              @click="viewAllCoursesEvent()"
              v-if="courseType == 1 && courses.qrCourse.length > 5"
              role="button"
              :aria-label="$t('message.View all QR Courses')"
            >
              {{ $t("message.View all QR Courses") }} ( {{ courseNum }} )
            </div>
            <div
              class="btn btn-primary SemiBold"
              @click="viewAllCoursesEvent()"
              v-if="courseType == 2 && courses.edxCourse.length > 5"
              role="button"
              :aria-label="$t('message.View all MOOC Courses')"
            >
              {{ $t("message.View all MOOC Courses") }} ( {{ courseNum }} )
            </div>
          </div>
        </div>

        <!-- related Occupation -->
        <div
          class="relatedOccupation"
          :class="{'relatedOccupationMobile': $route.name=='jobDetail'}"
          v-if="jobOccupationList.length > 0"
        >
          <div class="mainColor" style="padding-left: 15px">
            <h2 class="occupation-title">
              {{ $t("message.RelatedOccupation") }}
              <img
                class="relatedOccupation-deco-22 noSelect"
                src="../images/deco-22.png"
              />
            </h2>
          </div>
          <div class="relateOccuSwiper" :style="$route.name != 'jobDetail' && $store.state.innerWidth < 1345 && $store.state.innerWidth > 768 ? 'padding: 0 35px 0 39px;': ''">
            <SwiperOccupation ref="SwiperOccupation" :occupation-list="jobOccupationList"></SwiperOccupation>
          </div>
          <div class="center">
            <div
              class="btn btn-primary op-rc-Btn btnJia SemiBold"
              @click="viewAllOccupationEvent()"
              role="button"
              :aria-label="$t('message.View all')"
            >
              <a href="javascript:;" style="color: inherit">{{ $t("message.View all") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import Swiper from "@/components/Swiper.vue";
import ShareBar from "@/components/ShareBar.vue";
import { EventBus } from "@/javascripts/eventBus.js";
import SwiperQRcourses from "@/components/SwiperQRcourses.vue";
import SwiperMOOCcourses from "@/components/SwiperMOOCcourses.vue";
import SwiperOccupation from "@/components/SwiperOccupation.vue";

export default {
  data() {
    return {
      jobPostingDetail: {
        jobFunction: [],
        benefits: [],
        location: [],
      },
      showMore: false,
      jobid: 0,
      keyword: "",
      jobFunctionIds: "",
      jobFilterObj: {
        keyword: "",
        jobFunctionIds: "",
        level: "",
        type: "",
        jobSourceId: "",
        jobType: "",
      },
      haveRelated: false,
      courses: {
        qrCourse: [],
        edxCourse: [],
      },
      activeCourses: [],
      activeType: 1,
      courseType: 1,
      courseNum: 0,
      showJobCourse: false,
      swiperWidth:0,
      jobOccupationList: [],
    };
  },
  components: {
    Breadcrumbs,
    Swiper,
    ShareBar,
    SwiperQRcourses,
    SwiperMOOCcourses,
    SwiperOccupation,
  },
  props: ["jobPostingId", "childLogGaEvent", "logGaEvent"],
  methods: {
    getJobPostingDetail: function (id) {
      if (!id || id == -1) return;
      var that = this;
      this.api.getJobPostingDetail(
        {
          id: decodeURIComponent(decodeURIComponent(id)),
        },
        function (data) {
          that.$set(that, "jobPostingDetail", data.result);
          that.haveRelated = true;
          if (
            !that.jobPostingDetail.benefits ||
            (that.jobPostingDetail.benefits.length == 1 &&
              that.jobPostingDetail.benefits[0] == "")
          ) {
            that.jobPostingDetail.benefits = [];
          }
          if (
            !that.jobPostingDetail.location ||
            (that.jobPostingDetail.location.length == 1 &&
              that.jobPostingDetail.location[0] == "")
          ) {
            that.jobPostingDetail.location = [];
          }
          if (that.$route.path.indexOf("jobDetail") > 0) {
            var breadcrumbs = that.$route.meta.breadcrumbs.find(
              (b) => b.to.indexOf("jobDetail") > 0
            );
            if (breadcrumbs) {
              var description;
              if (
                that.$store.getters.getContent(that.jobPostingDetail.duties)
              ) {
                // 替換掉html標籤和換行符空格
                description =
                  that.$store.getters
                    .getContent(that.jobPostingDetail.duties)
                    .replace(/<[^>]+>/gi, "")
                    .replace(/[\r\n]/g, "")
                    .substring(0, 200) + "...";
                // description = that.$store.getters.getContent(that.jobPostingDetail.duties).replace(/<[^>]+>/ig, '').replace(/[\r\n\s]/g,'').substring(0,200)+"...";
              } else {
                description = "";
              }
              breadcrumbs.text = that.$store.getters.getContent(
                that.jobPostingDetail.title
              );
              document.title = that.$store.state.mate.title =
                that.$store.getters.getContent(that.jobPostingDetail.title) +
                that.$i18n.t("message.Job_title");
              that.$store.state.mate.description = description;
              that.$store.state.mate.keywords = that.$i18n.t(
                "message.Job_keywords"
              );
              breadcrumbs.to =
                "/jobDetail/" +
                that.$route.params.id +
                "?lang=" +
                that.$store.state.language +
                "&name=" +
                that.$store.getters.replaceEvent(
                  that.$store.getters.getContent(that.jobPostingDetail.title)
                );
            }
          }
        }
      );
    },
    getJobCourseList: function (id) {
      if (!id || id == -1) return;
      var that = this;
      this.api.getJobCourseList(
        { jobId: decodeURIComponent(id) },
        function (data) {
          that.courses = data.result;
          that.courseNum = data.result.qrTotalRows;
          for (let i = 0; i < that.courses.qrCourse.length; i++) {
            if (that.courses.qrCourse[i].learningMode) {
              that.courses.qrCourse[i].learningMode =
                that.courses.qrCourse[i].learningMode.split(",");
            }
          }
          for (let i = 0; i < that.courses.edxCourse.length; i++) {
            if (that.courses.edxCourse[i].learningMode) {
              that.courses.edxCourse[i].learningMode =
                that.courses.edxCourse[i].learningMode.split(",");
            }
          }
          if (
            that.courses.qrCourse.length == 0 &&
            that.courses.edxCourse.length > 0
          ) {
            that.courseType = 2;
          }
          that.activeCourses = that.courses.qrCourse;
          that.activeType = 1;
        }
      );
    },
    clickCourses: function (pathType, name) {
      this.courseType = pathType;
      pathType == 1
        ? (this.courseNum = this.courses.qrTotalRows)
        : (this.courseNum = this.courses.edxTotalRows);
      if (this.$refs.SwiperJob) {
        this.$refs.SwiperJob.setWidth();
      }
      if (this.$refs.SwiperPeople) {
        this.$refs.SwiperPeople.setWidth();
      }
      if (this.$refs.SwiperPeopleThree) {
        this.$refs.SwiperPeopleThree.setWidth();
      }
    },
    changeCourses: function (pathType, activeType) {
      this.activeType = activeType;
      this.activeCourses = this.courses[pathType];
      activeType == "1"
        ? (this.courseNum = this.courses.qrTotalRows)
        : (this.courseNum = this.courses.edxTotalRows);
    },
    goCourseDetail: function (course) {
      let key = "";
      // if (course.dataSource == 'edx') {
      key = encodeURIComponent(course.key);
      // } else {
      //     key = course.id
      // }
      this.$router.push({
        path: "/coursesDetail/" + course.dataSource + "/" + key,
        query: {
          lang: this.$store.state.language,
          name: this.$store.getters.replaceEvent(
            this.$store.getters.getObject(course.langMap).title
          ),
        },
      });
      window.scrollTo(0, 0);
    },
    viewAllCoursesEvent: function () {
      this.$store.state.formData.jobId = this.jobPostingDetail.id;
      if (this.$store.state.innerWidth > 768) {
        this.activeType == 1
          ? (this.$store.state.formData.coursesType = 1)
          : (this.$store.state.formData.coursesType = 2);
      } else {
        this.courseType == 1
          ? (this.$store.state.formData.coursesType = 1)
          : (this.$store.state.formData.coursesType = 2);
      }
      // if(this.activeType==1){
      // 	this.$store.state.formData.coursesType = 1;
      // }else if(this.activeType ==2){
      // 	this.$store.state.formData.coursesType = 2;
      // }
      this.$router.push({
        path: "/ReratedCoursesJ",
        query: { lang: this.$store.state.language },
      });
    },
    goJobList: function () {
      this.$store.state.formData.relatedJobType = 2;
      this.$store.state.formData.jobId = this.jobPostingDetail.id;
      if (this.childLogGaEvent)
        this.childLogGaEvent(
          "userClick",
          "Related Vacancies",
          "Related Vacancies"
        );
      else {
        this.logGaEvent("userClick", "Related Vacancies", "Related Vacancies");
      }
      this.$router.push({
        path: "/RelatedVacancies",
        query: { lang: this.$store.state.language },
      });
    },
    init: function () {
      if (this.jobPostingId) {
        this.jobid = this.jobPostingId;

        this.getJobPostingDetail(this.jobPostingId);
        this.getJobCourseList(this.jobPostingId);
        this.getJobOccupationList(this.jobPostingId);
      } else {
        this.jobid = this.$route.params.id;
        this.getJobPostingDetail(this.$route.params.id);
        this.getJobCourseList(this.$route.params.id);
        this.getJobOccupationList(this.$route.params.id);
      }
      if (this.$store.state.formData.jobFilterObj) {
        this.$store.state.formData.jobFilterObj.jobId = this.jobid;
      }
    },
    applyEvent: function () {
      if (this.childLogGaEvent)
        this.childLogGaEvent(
          "userClick",
          "applyNow",
          this.$store.getters.getContent(this.jobPostingDetail.onlineformURL)
        );
      else {
        this.logGaEvent(
          "userClick",
          "applyNow",
          this.$store.getters.getContent(this.jobPostingDetail.onlineformURL)
        );
      }
      window.open(
        this.$store.getters.getContent(this.jobPostingDetail.onlineformURL)
      );
    },
    hideJob: function () {
      this.haveRelated = false;
    },
    getJobOccupationList: function(id) {
      if (!id || id == -1) return;
      let that = this;
      let Base64 = require('js-base64').Base64;
      let obj = {
        jobId: decodeURIComponent(id),
        keyword: "",
        educationLevel: "",
        startRow: 0,
        maxRows: this.$route.name == "findAnOpportunity" ? 3 : 5,
      }
      this.api.getAllJobOccupationList(obj, function(data) {
        that.jobOccupationList = data.result;
      })
    },
    viewAllOccupationEvent: function() {
      this.$store.state.formData.jobId = this.jobPostingDetail.id;
      this.$router.push({
        path: "/RelatedOccupationsJ",
        query: { lang: this.$store.state.language },
      })
    }
  },
  mounted() {
    this.$store.state.mate.width = 209;
    this.$store.state.mate.height = 209;
    if (this.$store.state.innerWidth < 768) {
      window.scrollTo(0, 0);
    }
    if (this.$store.state.formData.jobFilterObj) {
      this.jobFilterObj = this.$store.state.formData.jobFilterObj;
    }
    this.$store.state.selectMenu = 3;
    // EventBus.$emit('error', { errMsg: this.$i18n.t("message.developmentTip")})
    if (
      this.$route.name == "findAnOpportunity" ||
      this.$route.name == "RelatedVacancies"
    ) {
      this.showJobCourse = true;
      var width = this.$store.state.innerWidth;
      if(this.$store.state.innerWidth>1320){
        width = 1320
      }
      this.swiperWidth = width*8/12;
    }
  },
  created() {
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    // 列表页面跳转到 详情页时，设置需要缓存
    if (to.name == "findAnOpportunity") {
      from.meta.isUseCache = false;
    }
    next();
  },
  computed: {
    count() {
      return this.$store.state.language;
    },
    innerwidth() {
      return this.$store.state.innerWidth;
    },
    _language() {
      return this.$store.state.language;
    },
    _jobId() {
      return this.$route.params.id;
    },
  },
  watch: {
    jobPostingId() {
      if (this.jobPostingId) {
        this.getJobPostingDetail(this.jobPostingId);
        this.getJobCourseList(this.jobPostingId);
        this.getJobOccupationList(this.jobPostingId);
      }
    },
    _jobId: {
      handler: function (val, oldVal) {
        if (
          this.$route.params.id &&
          this.$route.path.indexOf("jobDetail") > 0
        ) {
          this.init();
        }
      },
      deep: true,
    },
    _language: {
      handler: function (val, oldVal) {
        let that = this;
        if (this.$route.path.indexOf("jobDetail") > 0) {
          var breadcrumbs = this.$route.meta.breadcrumbs.find(
            (b) => b.to.indexOf("jobDetail") > 0
          );
          // this.$router.push({query: {lang: val,name:this.$store.getters.replaceEvent(this.$store.getters.getContent(this.jobPostingDetail.title))}})
          if (breadcrumbs) {
            var description;
            if (that.$store.getters.getContent(that.jobPostingDetail.duties)) {
              // 替換掉html標籤和換行符空格
              description =
                that.$store.getters
                  .getContent(that.jobPostingDetail.duties)
                  .replace(/<[^>]+>/gi, "")
                  .replace(/[\r\n]/g, "")
                  .substring(0, 200) + "...";
              // description = that.$store.getters.getContent(that.jobPostingDetail.duties).replace(/<[^>]+>/ig, '').replace(/[\r\n\s]/g,'').substring(0,200)+"...";
            } else {
              description = "";
            }
            breadcrumbs.text = this.$store.getters.getContent(
              this.jobPostingDetail.title
            );
            document.title = this.$store.state.mate.title =
              this.$store.getters.getContent(this.jobPostingDetail.title) +
              this.$i18n.t("message.Job_title");
            this.$store.state.mate.description = description;
            this.$store.state.mate.keywords = this.$i18n.t(
              "message.Job_keywords"
            );
            breadcrumbs.to =
              "/jobDetail/" +
              this.$route.params.id +
              "?lang=" +
              this.$store.state.language +
              "&name=" +
              this.$store.getters.replaceEvent(
                this.$store.getters.getContent(this.jobPostingDetail.title)
              );
          }
        }
      },
      deep: true,
    },
  },
};
</script>